export const MIN_HOURS_TO_CANCEL_JOB = 3
export const USER_STATUS_NOT_ALLOW_MESSAGE = 'User status does not allow this action'
